module.exports = __webpack_public_path__ + "static/media/CompanyProfilemap@2x.a383491e.png";